import React from "react";

const SolutionTabs = ({ solutions, activeIndex, onTabClick }) => {
  return (
    <div className="hidden lg:block">
      <div className="flex flex-wrap space-x-1 sm:space-x-2 md:space-x-4 lg:space-x-6 items-center">
        {solutions.map((solution, i) => {
          return (
            <div  
              key={i}  
              className="items-center cursor-pointer"
              onClick={() => onTabClick(solution.index)}
            >
              <div className="pb-3 sm:pb-4">
                <div className={`w-[80px] h-[80px] sm:w-[100px] sm:h-[100px] lg:w-[120px] lg:h-[120px] bg-gray-100 rounded-full shadow-lg flex justify-center items-center drop-shadow-2xl 
                                 transition ease-in-out duration-500 hover:bg-rose-800 hover:text-white hover:scale-110
                                ${activeIndex === solution.index ? 'scale-110 bg-rose-800 text-white animate-selectedTab ring-4 ring-rose-300/60' : ''}`}>
                  <span className="text-sm sm:text-base lg:text-xl text-center font-['S-Core Dream']">
                    {solution.name}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SolutionTabs; 